import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot/index";
import axios from "axios";

// get inventory
export const getInventoryInvertor = createAsyncThunk("inventory/get inventory Invertor list resp", async (data) => {
    const token = localStorage.getItem("authToken")
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/finance/app/v1/getlist-inventoryInvertor`, data, { 
            headers: {
                "auth-token": token,
            }
        },);
        console.log({ response })
        console.log("testing invertor Data", response)
        return response;
    } catch (error) {
        console.error('Error fetching inventory - ', error);
        throw error;
    }
})


